<template>
  <div class="login--panel col-xl-6 col-sm-12 display-flex flex-wrap">
    <section class="display-flex flex-wrap justify-content-center align-items-center w-100">
      <div class="d-block " style="margin: 0 auto">
        <div class="display-flex flex-wrap w-100 justify-content-center">
          <img src="../../assets/logo.png" style="margin-bottom: 20px">
          <section class="login--panel-header">
            <h2 style="letter-spacing: 4px">
              Vouchery Blue Diamond
            </h2>
            <div class="w-100 display-flex justify-content-center mt-3 mb-5">
              <h5 style="color: #bdbdbd; text-align: center">Witaj ponownie</h5>
            </div>
          </section>
<!--          <section class="login&#45;&#45;panel-header">-->
<!--            <h2 style="letter-spacing: 4px">-->
<!--              Vouchery Blue Diamond-->
<!--            </h2>-->
<!--            <div class="w-100 display-flex justify-content-center mt-3 mb-5">-->
<!--              <h2 style="color: #3B3B53; text-align: center">Przerwa techniczna</h2>-->
<!--            </div>-->
<!--          </section>-->
          <form class="login--form" @submit.prevent="onLogin()">
            <fieldset class="w-100">
              <v-text-field
                v-validate="'required'"
                v-model="formData.email"
                data-vv-name="login"
                :error-messages="errors.collect('login')"
                browser-autocomplete="off"
                placeholder="Adres e-mail">
              </v-text-field>
            </fieldset>
            <fieldset class="w-100">
              <v-text-field
                v-validate="'required'"
                :error-messages="errors.collect('password')"
                data-vv-name="password"
                v-model="formData.password"
                type="password"
                placeholder="Hasło">
              </v-text-field>
            </fieldset>
            <div class="w-100 display-flex justify-content-between align-items-center">
              <fieldset class="w-100">
                <v-checkbox
                  label="Zapamiętaj mnie"
                  v-model="checkbox"
                ></v-checkbox>
              </fieldset>
              <router-link :to="'/remind-password'"
                           class="login--link white-space-nowrap">
                Zapomniałem hasła
              </router-link>
            </div>
            <div class="login--button-wrapper w-100 display-flex justify-content-end">
              <button type="submit"
                      class="button--primary">
                Zaloguj się
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  import { mapActions } from 'vuex';

  export default {
    name: 'Login',
    data() {
      return {
        formData: Object({}),
        isSubmitted: Boolean(false),
        checkbox: false,
      };
    },
    methods: {
      ...mapActions('AuthStore', ['login']),
      onLogin() {
        this.$validator.validateAll()
          .then((isValid) => {
            if (!isValid) {
              this.isSubmitted = true;
            } else {
              this.isSubmitted = false;
              this.login(this.formData).then(() => {
                this.$router.push('panel');
              });
            }
          });
      },
    },
  };
</script>

<style scoped lang="scss">
  @import "../../styles/login";
</style>
